import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {PrestacionModel} from "../models/prestacion.model";

@Injectable({
    providedIn: 'root'
})
export class PrestacionSocialService {

    // Private
    private filtro = {};

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Page prestaciones
     *
     * @param params
     */
    getPrestaciones(params: any): Observable<any> {
        let options: HttpParams = new HttpParams();

        if (params) {
            Object.keys(params).forEach(key => {
                options = options.set(key, params[key]);
            });
            if (this.filtro) {
                for (const key in this.filtro) {
                    if (this.filtro.hasOwnProperty(key)) {
                        options = options.set(key, this.filtro[key].toString());
                    }
                }
            }
        }
        return this._httpClient.get<any>(
            '/api/seaged-gobierno-saga-registro-prestaciones/v1/expedientes/prestaciones-sociales',
            {params: options}).pipe(
            map(response => response)
        );
    }

    updatePrestacion(data: PrestacionModel, id: string): Observable<any> {
        return this._httpClient.put<any>(
            `/api/seaged-gobierno-saga-registro-prestaciones/v1/expedientes/prestaciones-sociales/${id}`,
            data).pipe(
            map(response => response)
        );
    }

    public addFilter(key, value) {
        if (value) {
            this.filtro[key] = value;
        }
    }

    public deleteAllFilter() {
        this.filtro = {};
    }
}
